module.exports = __webpack_public_path__ + "static/media/grow-learn-apply.ba21a73d.svg";